"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const ApiCredentialsCard_1 = require("../ApiCredentialsCard");
const IntegrationSharedSettings_1 = require("../IntegrationSharedSettings");
const react_2 = require("@osmosys/react");
const react_if_1 = require("react-if");
const hooks_1 = require("../../../../hooks");
const reactstrap_1 = require("reactstrap");
const SalesforceCategorySelectOption = (o) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        o.name,
        " ",
        react_1.default.createElement(reactstrap_1.Badge, { color: "light" }, o.categoryType),
        ' ',
        !o.parentId && react_1.default.createElement(reactstrap_1.Badge, { color: "dark" }, "top level"),
        ' ',
        o.allowsChildren ? react_1.default.createElement(reactstrap_1.Badge, { color: "success" }, "allows children") : ''));
};
exports.SalesforceSettings = ({ integration }) => {
    const { featureFlags: { useNewSalesforceCategoryInterfaces }, } = hooks_1.useOsmosysContext();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reusables_1.Form, { mutationProps: {
                mutation: graphql_1.createOrUpdateSalesforce,
                refetchQueries: [
                    {
                        query: graphql_1.integration,
                        variables: {
                            id: integration.id,
                        },
                    },
                ],
            }, valuesToVariables: values => {
                return {
                    data: {
                        clientId: values.clientId.trim(),
                        clientSecret: values.clientSecret.trim(),
                        clientSubDomain: values.clientSubDomain.trim(),
                        name: values.name.trim(),
                        salesforceAccountId: values.salesforceAccountId && values.salesforceAccountId.trim()
                            ? values.salesforceAccountId.trim()
                            : null,
                        salesforceAssetCategoryId: values.salesforceAssetCategory
                            ? values.salesforceAssetCategory.salesforceId
                            : null,
                        salesforceContentCategoryId: values.salesforceContentCategory
                            ? values.salesforceContentCategory.salesforceId
                            : null,
                        salesforceOsmosysCategoryId: values.salesforceOsmosysCategory
                            ? values.salesforceOsmosysCategory.salesforceId
                            : null,
                        salesforceSendCategoryId: values.salesforceSendCategory
                            ? values.salesforceSendCategory.salesforceId
                            : null,
                        salesforceSendClassificationId: values.salesforceSendClassification
                            ? values.salesforceSendClassification.salesforceId || null
                            : null,
                        salesforceTestSendCategoryId: values.salesforceTestSendCategory
                            ? values.salesforceTestSendCategory.salesforceId
                            : null,
                        salesforceUserInitiatedSendsCategoryId: values.salesforceUserInitiatedSendsCategory
                            ? values.salesforceUserInitiatedSendsCategory.salesforceId
                            : null,
                        useSalesforceApiVersionTwo: values.useSalesforceApiVersionTwo === true,
                    },
                    id: integration.id,
                };
            }, formikProps: {
                initialValues: {
                    clientId: integration.clientId,
                    clientSecret: integration.clientSecret,
                    clientSubDomain: integration.clientSubDomain,
                    name: integration.name,
                    salesforceAccountId: integration.salesforceAccountId || '',
                    salesforceAssetCategory: integration.salesforceAssetCategory,
                    salesforceContentCategory: integration.salesforceContentCategory,
                    salesforceOsmosysCategory: integration.salesforceOsmosysCategory,
                    salesforceSendCategory: integration.salesforceSendCategory,
                    salesforceSendClassification: integration.salesforceSendClassification,
                    salesforceTestSendCategory: integration.salesforceTestSendCategory,
                    salesforceUserInitiatedSendsCategory: integration.salesforceUserInitiatedSendsCategory,
                    useSalesforceApiVersionTwo: integration.useSalesforceApiVersionTwo,
                },
                validationSchema: () => Yup.object().shape({
                    clientId: Yup.string().trim(),
                    clientSecret: Yup.string().trim(),
                    name: Yup.string()
                        .trim()
                        .required('Required'),
                    useSalesforceApiVersionTwo: Yup.boolean().required('Required'),
                }),
            }, showBottomToolbar: true }, formikProps => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(IntegrationSharedSettings_1.IntegrationSharedSettings, { integration: integration, formikProps: formikProps, sidebar: react_1.default.createElement(ApiCredentialsCard_1.ApiCredentialsCard, null,
                    react_1.default.createElement(reusables_1.FormGroup, { label: "API client sub domain", name: "clientSubDomain", type: "text", autoComplete: "off" }),
                    react_1.default.createElement(reusables_1.FormGroup, { label: "Account ID", name: "salesforceAccountId", autoComplete: "off" }),
                    react_1.default.createElement(reusables_1.FormGroup, { label: "API client ID", name: "clientId", type: "password", autoComplete: "off" }),
                    react_1.default.createElement(reusables_1.FormGroup, { label: "API client secret key", name: "clientSecret", type: "password", autoComplete: "off" }),
                    react_1.default.createElement(react_2.OsmosysToggler, { on: formikProps.values.useSalesforceApiVersionTwo, boldLabel: true, offLabel: "V1", onLabel: "V2", id: "useSalesforceApiVersionTwo", toggle: () => formikProps.setFieldValue('useSalesforceApiVersionTwo', !formikProps.values.useSalesforceApiVersionTwo) }, "API version"),
                    react_1.default.createElement(reusables_1.ConnectionStatus, { canConnect: integration.canConnectToREST, connectedText: "Connected to the REST API", disconnectedText: "Cannot connect to the REST API" }),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(reusables_1.ConnectionStatus, { canConnect: integration.canConnectToSOAP, connectedText: "Connected to the SOAP API", disconnectedText: "Cannot connect to the SOAP API" }),
                    integration.accessTokenExpiryDate && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("br", null),
                        react_1.default.createElement("small", { style: { fontSize: 12 } },
                            "Access token expires at",
                            ' ',
                            moment_1.default(integration.accessTokenExpiryDate).format('LT'))))) },
                react_1.default.createElement(react_if_1.When, { condition: !!(useNewSalesforceCategoryInterfaces &&
                        integration.canConnectToREST &&
                        integration.canConnectToSOAP) },
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(react_2.OsmosysSelectBox, { value: formikProps.values.salesforceSendClassification, label: "Default send classification", boldLabel: true, filterOption: () => {
                            return true;
                        }, query: graphql_1.salesforceSendClassifications, variables: {
                            integrationId: integration.id,
                        }, paths: {
                            count: 'salesforceSendClassifications.count',
                            label: 'name',
                            list: 'salesforceSendClassifications.edges',
                            value: 'id',
                        }, onChange: val => {
                            formikProps.setFieldValue('salesforceSendClassification', val);
                        }, resourceName: "SalesforceSendClassification", resourceNamePlural: "SalesforceSendClassifications", clearable: true }),
                    react_1.default.createElement("hr", null),
                    react_1.default.createElement("h5", null, "Content asset folders"),
                    react_1.default.createElement(react_2.OsmosysSelectBox, { value: formikProps.values.salesforceAssetCategory, label: "Parent asset folder", boldLabel: true, filterOption: () => {
                            return true;
                        }, query: graphql_1.salesforceCategories, formatOptionLabel: (o) => {
                            return react_1.default.createElement(SalesforceCategorySelectOption, Object.assign({}, o));
                        }, variables: {
                            categoryType: 'asset',
                            integrationId: integration.id,
                        }, paths: {
                            count: 'salesforceCategories.count',
                            label: 'name',
                            list: 'salesforceCategories.edges',
                            value: 'salesforceId',
                        }, onChange: val => {
                            formikProps.setFieldValue('salesforceAssetCategory', val);
                        }, resourceName: "SalesforceCategory", resourceNamePlural: "SalesforceCategories", clearable: true }),
                    react_1.default.createElement(react_2.OsmosysSelectBox, { value: formikProps.values.salesforceContentCategory, label: "Osmosys asset folder", boldLabel: true, filterOption: () => {
                            return true;
                        }, query: graphql_1.salesforceCategories, formatOptionLabel: (o) => {
                            return react_1.default.createElement(SalesforceCategorySelectOption, Object.assign({}, o));
                        }, variables: {
                            integrationId: integration.id,
                        }, paths: {
                            count: 'salesforceCategories.count',
                            label: 'name',
                            list: 'salesforceCategories.edges',
                            value: 'salesforceId',
                        }, onChange: val => {
                            formikProps.setFieldValue('salesforceContentCategory', val);
                        }, resourceName: "SalesforceCategory", resourceNamePlural: "SalesforceCategories", clearable: true, disabled: true, placeholder: "Automatic" }),
                    react_1.default.createElement("hr", null),
                    react_1.default.createElement("h5", null, "Email send folders"),
                    react_1.default.createElement(react_2.OsmosysSelectBox, { value: formikProps.values.salesforceUserInitiatedSendsCategory, label: "Parent user-initiated send folder", boldLabel: true, filterOption: () => {
                            return true;
                        }, query: graphql_1.salesforceCategories, formatOptionLabel: (o) => {
                            return react_1.default.createElement(SalesforceCategorySelectOption, Object.assign({}, o));
                        }, variables: {
                            categoryType: 'userinitiatedsends',
                            integrationId: integration.id,
                        }, paths: {
                            count: 'salesforceCategories.count',
                            label: 'name',
                            list: 'salesforceCategories.edges',
                            value: 'salesforceId',
                        }, onChange: val => {
                            formikProps.setFieldValue('salesforceUserInitiatedSendsCategory', val);
                        }, resourceName: "SalesforceCategory", resourceNamePlural: "SalesforceCategories", clearable: true }),
                    react_1.default.createElement(react_2.OsmosysSelectBox, { value: formikProps.values.salesforceTestSendCategory, label: "Osmosys user-initiated test send folder", boldLabel: true, filterOption: () => {
                            return true;
                        }, query: graphql_1.salesforceCategories, formatOptionLabel: (o) => {
                            return react_1.default.createElement(SalesforceCategorySelectOption, Object.assign({}, o));
                        }, variables: {
                            categoryType: 'userinitiatedsends',
                            integrationId: integration.id,
                        }, paths: {
                            count: 'salesforceCategories.count',
                            label: 'name',
                            list: 'salesforceCategories.edges',
                            value: 'salesforceId',
                        }, onChange: val => {
                            // formikProps.setFieldValue(
                            //   'salesforceTestSendCategory',
                            //   val
                            // );
                        }, resourceName: "SalesforceCategory", resourceNamePlural: "SalesforceCategories", clearable: true, disabled: true, placeholder: "Automatic" }),
                    react_1.default.createElement(react_2.OsmosysSelectBox, { value: formikProps.values.salesforceSendCategory, label: "Osmosys user-initiated send folder", boldLabel: true, filterOption: () => {
                            return true;
                        }, query: graphql_1.salesforceCategories, formatOptionLabel: (o) => {
                            return react_1.default.createElement(SalesforceCategorySelectOption, Object.assign({}, o));
                        }, variables: {
                            categoryType: 'userinitiatedsends',
                            integrationId: integration.id,
                        }, paths: {
                            count: 'salesforceCategories.count',
                            label: 'name',
                            list: 'salesforceCategories.edges',
                            value: 'salesforceId',
                        }, onChange: val => {
                            // formikProps.setFieldValue(
                            //   'salesforceTestSendCategory',
                            //   val
                            // );
                        }, resourceName: "SalesforceCategory", resourceNamePlural: "SalesforceCategories", clearable: true, disabled: true, placeholder: "Automatic" }),
                    react_1.default.createElement("hr", null),
                    react_1.default.createElement(react_2.OsmosysSelectBox, { value: null, label: "All folders", boldLabel: true, filterOption: () => {
                            return true;
                        }, query: graphql_1.salesforceCategories, formatOptionLabel: (o) => {
                            return react_1.default.createElement(SalesforceCategorySelectOption, Object.assign({}, o));
                        }, variables: {
                            integrationId: integration.id,
                        }, paths: {
                            count: 'salesforceCategories.count',
                            label: 'name',
                            list: 'salesforceCategories.edges',
                            value: 'salesforceId',
                        }, onChange: val => {
                            formikProps.setFieldValue('salesforceOsmosysCategory', val);
                        }, resourceName: "SalesforceCategory", resourceNamePlural: "SalesforceCategories", placeholder: "See all folders here, just FYI" }),
                    react_1.default.createElement(react_2.OsmosysDiv, { style: { height: '300px', width: '100%' } }))))))));
};
//# sourceMappingURL=SalesforceSettings.js.map